import styled from "styled-components";

import { Modal } from "components/Modal";
import { calculateRem } from "styles/mixins/calculateRem";

export const StyledModal = styled(Modal)`
  border-radius: 0;
  height: 100vh;
  width: ${calculateRem(300)};
  padding: 2rem 1.4rem;
`;
